/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AdditionalRecipientCreate from "../../../../AdditionalRecipientCreate";
import AdditionalRecipients from "../../../../_utils/AccountCreationComponents/AdditionalRecipients";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import CategoriesEdit from "../../../../_utils/AccountCreationComponents/CategoriesEdit";
import CommonLayout from "../../../../_utils/CommonLayout";
import CommonAssignLabelPopup from "../../../../_utils/CommonPopups/CommonAssignLabelPopup";

const BeneAccountStepCategories = (props) => {
  const { id } = useParams();
  const categories = props.categories;
  const [labels, setLabels] = useState([]);
  const [labelpopup, setLabelpopup] = useState(false);
  const [tempRecipients, setTempRecipients] = useState([]);
  const [originalRecipients, setOriginalRecipients] = useState([]);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [initialRecipientCount] = useState(0);
  const [showAdditionalSection, setShowAdditionalSection] = useState(false);
  const [showAdditionalRecipient, setShowAdditionalRecipient] = useState([]);
  const [recipientButtonDisabled, setRecipientButtonDisabled] = useState(true);
  const [additionalChip, setAdditionalChip] = useState(showAdditionalRecipient);

  const openAdditionalRecipients = () => {
    const confirmed = props?.createRecipient || [];
    setTempRecipients(confirmed);
    setOriginalRecipients(confirmed);
    setShowAdditionalSection(true);
  };

  const handleConfirmRecipients = () => {
    if (recipientButtonDisabled) return;

    props?.setCreateRecipient(tempRecipients);
    setShowAdditionalSection(false);
  };

  useEffect(() => {
    const changed =
      JSON.stringify(tempRecipients) !== JSON.stringify(originalRecipients);

    setRecipientButtonDisabled(!changed);
  }, [tempRecipients, originalRecipients]);

  const toggleSelection = (category) => {
    const categoryId = category.id;
    props?.setSelectedCatFields((prevSelectedFields) => {
      let updatedSelectedFields;

      if (categoryId === "Select All") {
        const isAllSelected = prevSelectedFields.length === categories.length;
        props?.setSelectAllChecked(!isAllSelected);
        updatedSelectedFields = isAllSelected
          ? []
          : categories.map((cat) => cat.id);
      } else {
        if (prevSelectedFields.includes(categoryId)) {
          updatedSelectedFields = prevSelectedFields.filter(
            (id) => id !== categoryId,
          );
        } else {
          updatedSelectedFields = [...prevSelectedFields, categoryId];
        }
        props?.setSelectAllChecked(
          updatedSelectedFields.length === categories.length,
        );
      }

      return updatedSelectedFields;
    });
  };

  const handleCategorySelect = (selectedCategories) => {
    let selectedCategoryNames = [];

    if (selectedCategories.length > 0) {
      selectedCategoryNames = selectedCategories
        .map((categoryId) => {
          const category = categories.find(
            (category) => category.id === categoryId,
          );
          return category ? category.name : null;
        })
        .filter((name) => name !== null);
    } else {
      selectedCategoryNames = categories.map((category) => category.name);
    }

    props.onSelectFieldsChange(selectedCategoryNames);
  };

  useEffect(() => {
    const availableLabels = sessionStorage?.getItem("AvailableLabels");
    if (availableLabels) {
      try {
        const parsedLabels = JSON.parse(availableLabels);
        setLabels(parsedLabels || []);
      } catch (err) {
        console.error("Failed to parse AvailableLabels", err);
        setLabels([]);
      }
    }
  }, []);

  useEffect(() => {
    if (labelpopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [labelpopup]);

  const handleClose = (finalLabels) => {
    setLabelpopup(false);

    if (finalLabels === undefined || finalLabels === null) return;

    props?.setPayload((prevPayload) => ({
      ...prevPayload,
      labels: finalLabels,
    }));

    props.setSelectedLabelsCreate(finalLabels);
  };

  useEffect(() => {
    handleCategorySelect(props?.selectedCatFields);
  }, [props?.selectedCatFields]);

  useEffect(() => {
    if (labelpopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [labelpopup]);

  return (
    <>
      {showAdditionalSection && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <AdditionalRecipientCreate
            type="createFlow"
            finalRecipients={props?.createRecipient}
            initialRecipientCount={initialRecipientCount}
            setShowAdditionalSection={setShowAdditionalSection}
            accountID={id}
            showAdditionalRecipient={showAdditionalRecipient}
            setShowAdditionalRecipient={setShowAdditionalRecipient}
            handleConfirm={handleConfirmRecipients}
            recipients={tempRecipients}
            setRecipients={setTempRecipients}
            buttonDisabled={recipientButtonDisabled}
            setButtonDisabled={setRecipientButtonDisabled}
            additionalChip={additionalChip}
            setAdditionalChip={setAdditionalChip}
          />
        </div>
      )}

      {labelpopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext={
              "Labels will be used to generate statistics for the associated accounts."
            }
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            isLabelPopupOpen={labelpopup}
            selectedLabelsCreate={props?.selectedLabelsCreate}
            setSelectedLabelsCreate={props?.setSelectedLabelsCreate}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            type="create"
          />
        </div>
      )}
      <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base max-w-tab-width-normal w-full mx-auto">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <CategoriesEdit
              type="CategoryCreate"
              sortedCategories={categories}
              selectedCategories={props?.selectedCatFields}
              handleCategorySelect={toggleSelection}
              Title={"Categories"}
              SubTitle="Not selecting categories will assign all, including future ones, to this account. This is not recommended for security reasons."
              TitleFontcolor="text-primary"
              TextSize="font-md"
              SubTitleFontcolor="text-secondary"
              SubTitleTextSize="font-xs"
              TitleFontWeight="semibold"
              SubTitleFontWeight="normal"
            />
          </div>
          <div className="w-width-full lg:max-w-[var(--create-box-width)] flex flex-col gap-gap-md">
            <AssignLabels
              setLabelpopup={setLabelpopup}
              labels={props?.payload?.labels}
              subText1="Labels will be used to generate statistics for the associated
                accounts."
              isOptional={true}
            />
            <div className="pb-padding-md">
              <AdditionalRecipients
                setShowAdditionalSection={openAdditionalRecipients}
                recipients={props?.createRecipient}
              />
            </div>
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default BeneAccountStepCategories;
